export const NOTIFICATION_TYPE_LABELS = {
  reply: 'Reply',
  mention: 'Mention',
  vote: 'Upvote',
  downvote: 'Downvote',
  follow: 'Follow',
  reblog: 'Reblog',
  transfer: 'Transfer',
  favourite_author_post: 'Favourite Author',
  favourite_author_comment: 'List Author Comment',
  favourite_author_short: 'List Author Short',
  posting_key_invalid: 'Posting Key Alert',
};

export const NOTIFICATION_TYPE_PAST_TENSE = {
  mention: 'mentioned',
  reply_mention: 'replied to and mentioned',
  vote: 'upvoted',
  downvote: 'downvoted',
  follow: 'followed',
  reblog: 'reblogged',
  favourite_author_post: 'posted',
  favourite_author_comment: 'commented',
  favourite_author_short: 'posted a short',
  posting_key_invalid: 'alerted you about',
};

export const ALL_NOTIFICATION_TYPES = Object.keys(NOTIFICATION_TYPE_LABELS);

export const getDefaultNotificationFilterTypes = () => [...ALL_NOTIFICATION_TYPES];

export default NOTIFICATION_TYPE_LABELS;
